export enum StretchingType {
  'left' = 'left',
  'right' = 'right',
}
